module.exports = __webpack_public_path__ + "img/users-white.657aa694.svg";